import React from 'react';
import PropTypes from 'prop-types';

import Layout from '../components/Layout';
import SEO from '../components/Seo';
import MainScreen from '../components/MainScreen';
import Acuity from '../components/mainScreen/Acuity';
import Features from '../components/Features';
import Footer from '../components/Footer';
import { TEXT } from '../locals';
import { withLocation } from '../hoc/withLocation';
import { isLogin, logout as logOut } from '../util';
import 'normalize.css';
import '../styles/main.scss';

const { MAIN } = TEXT;

// TODO: Make PropTypes everywhere.

const IndexPage = ({ search }) => {
  const { logout } = search;
  if (logout) {
    logOut();
  } else {
    isLogin();
  }
  return (
    <Layout>
      <SEO title={MAIN.SEO_TITLE} />
      <MainScreen />
      <Features />
      <Acuity />
      <Footer />
    </Layout>
  );
};

IndexPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  search: PropTypes.any,
};

IndexPage.defaultProps = {
  search: {},
};
export default withLocation(IndexPage);
